import { LoggingApi, LoggingApiFilter } from "models/LoggingApi";
import React, { useCallback, useMemo, useState } from "react";
import { logginApiRepository } from "repositories/logging-api-repository";
import {
  FilterActionEnum,
  filterService,
} from "services/page-services/filter-service";
import { listService } from "services/page-services/list-service";
import { queryStringService } from "services/page-services/query-string-service";
import { useTranslation } from "react-i18next";
import {
  ActionBarComponent,
  AdvanceDateRangeFilter,
  AdvanceIdFilterMaster,
  Button,
  InputSearch,
  LayoutCell,
  LayoutHeader,
  OneLineText,
  Pagination,
  StandardTable,
  TagFilter,
} from "react3l-ui-library";
import nameof from "ts-nameof.macro";
import { DateFilter, GuidFilter, IdFilter } from "react3l-advanced-filters";
import {
  getAntOrderType,
  tableService,
} from "services/page-services/table-service";
import { ColumnProps } from "antd/lib/table";
import { Moment } from "moment";
import { formatDateTime } from "helpers/date-time";
import {
  ArrowDown16,
  Copy16,
  Download16,
  TrashCan16,
  WatsonHealthRotate_36024 as WatsonHealthRotate36024,
} from "@carbon/icons-react";
import appMessageService from "services/common-services/app-message-service";
import { AxiosError } from "axios";
import { notification, Select, Spin, Tooltip } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { cloneDeep } from "lodash";
import { importExportService } from "../../../services/page-services/import-export-service";
import memoize from "fast-memoize";
import moment from "moment";

function AppLoggingApiMaster() {
  const [loading, setLoading] = useState(false);
  const [translate] = useTranslation();
  // const { createdAt }: any = queryStringService.useGetQueryString("createdAt");

  const [arrFilterConstructionModule] = React.useState([
    {
      id: 1,
      code: "/budget/",
      name: "Ngân sách",
      value: "Ngân sách",
      label: "Ngân sách",
      codeName: "Budget",
    },
    {
      id: 2,
      code: "/construction/",
      name: "Xây dựng",
      value: "Xây dựng",
      label: "Xây dựng",
      codeName: "Construction",
    },
    {
      id: 3,
      code: "/investment/",
      name: "Đầu tư",
      value: "Đầu tư",
      label: "Đầu tư",
      codeName: "Investment",
    },
    {
      id: 4,
      code: "/inventory/",
      name: "Kho hàng",
      value: "Kho hàng",
      label: "Kho hàng",
      codeName: "Inventory",
    },
    {
      id: 5,
      code: "/purchase/",
      name: "Mua hàng",
      value: "Mua hàng",
      label: "Mua hàng",
      codeName: "Purchase",
    },
    {
      id: 6,
      code: "/portal/",
      name: "Portal",
      value: "Portal",
      label: "Portal",
      codeName: "Portal",
    },
    {
      id: 7,
      code: "/pmdm/",
      name: "Master Data",
      value: "Master Data",
      label: "Master Data",
      codeName: "Master Data",
    },
  ]);

  const [modelFilter, dispatch] = queryStringService.useQueryString(
    LoggingApiFilter,
    {
      skip: 0,
      take: 10,
      createdAt: {
        greaterEqual: moment().subtract(1, "months"),
        lessEqual: moment(),
      },
    }
  );

  const { notifyUpdateItemError, notifyUpdateItemSuccess } =
    appMessageService.useCRUDMessage();

  const {
    value: filter,
    handleChangeInputSearch,
    handleChangeAllFilter,
  } = filterService.useFilter(modelFilter, dispatch);

  const checkIfIsWithinThirtyOneDays = React.useCallback((date0, date1) => {
    if (!date0 || !date1) return false;
    const startDate = moment(date0);
    const endDate = moment(date1);
    return endDate.diff(startDate, "days") <= 31;
  }, []);

  const handleChangeDateFilter = React.useMemo(
    () =>
      memoize(
        (config: { fieldName: string; fieldType: string | [string, string] }) =>
          (date: [Moment, Moment]) => {
            const { fieldName, fieldType } = config;
            const isWithinThirtyOneDays = checkIfIsWithinThirtyOneDays(
              date[0],
              date[1]
            );
            if (isWithinThirtyOneDays) {
              if (date[0] && date[1]) {
                dispatch({
                  type: FilterActionEnum.UPDATE,
                  payload: {
                    [fieldName]: new DateFilter({
                      [fieldType[0]]: date[0]?.startOf("day"),
                      [fieldType[1]]: date[1]?.endOf("day"),
                    }),
                    skip: 0,
                  } as LoggingApiFilter,
                });
              } else if (!date[0] && !date[1]) {
                dispatch({
                  type: FilterActionEnum.UPDATE,
                  payload: {
                    [fieldName]: new DateFilter({
                      [fieldType[0]]: moment().subtract(1, "months"),
                      [fieldType[1]]: moment(),
                    }),
                    skip: 0,
                  } as LoggingApiFilter,
                });
              } else {
                dispatch({
                  type: FilterActionEnum.UPDATE,
                  payload: {
                    [fieldName]: new DateFilter({
                      [fieldType as unknown as string]: date[0]?.startOf("day"),
                    }),
                    skip: 0,
                  } as LoggingApiFilter,
                });
              }
            } else
              notification.error({
                placement: "bottomRight",
                message:
                  "Vui lòng chọn khoảng thời gian tìm kiếm trong vòng 31 ngày",
              });
          }
      ),
    [checkIfIsWithinThirtyOneDays, dispatch]
  );

  const handleChangeSelectFilterHere = React.useMemo(
    () =>
      memoize(
        (config: {
            fieldName: string;
            fieldType: string;
            classFilter: new (partial?: any) => IdFilter | GuidFilter;
          }) =>
          (idValue: number, value: LoggingApi) => {
            const { fieldName, fieldType, classFilter: ClassFilter } = config;
            value.name = `${value?.id} - ${value?.code}`;
            dispatch({
              type: FilterActionEnum.UPDATE,
              payload: {
                [`${fieldName}Value`]: value,
                [`${fieldName}`]: Object.assign(new ClassFilter(), {
                  [fieldType]: idValue,
                }),
                skip: 0,
              },
            });
          }
      ),
    [dispatch]
  );

  // , loadingList, handleResetList,
  const { list, count, loadingList, handleResetList } = listService.useList(
    logginApiRepository.list,
    logginApiRepository.count,
    filter,
    dispatch
  );

  const { handleListExport } = importExportService.useExport();

  const handleSend = useCallback(
    (id: number) => {
      setLoading(true);
      logginApiRepository.send(id).subscribe({
        next: (item: any) => {
          notifyUpdateItemSuccess();
          handleResetList();
          setLoading(false);
        },
        error: (error: AxiosError<LoggingApi>) => {
          if (error.response && error.response.status === 400) {
            notifyUpdateItemError();
          }
          if (
            error.response &&
            error.response.status === 400 &&
            error?.response?.data?.errors?.id
          ) {
            notifyUpdateItemError({
              message: String(error?.response?.data?.errors?.id),
            });
          }
          setLoading(false);
        },
      });
    },
    [notifyUpdateItemError, notifyUpdateItemSuccess, handleResetList]
  );

  const { handleTableChange, handlePagination } = tableService.useTable(
    filter,
    handleChangeAllFilter
  );

  const {
    handleBulkAction,
    canBulkAction,
    rowSelection,
    selectedRowKeys,
    setSelectedRowKeys,
  } = listService.useRowSelection(
    logginApiRepository.delete,
    logginApiRepository.bulkDelete,
    null,
    null,
    null,
    handleResetList
  );

  const handleChangeFilterConstructionModule = React.useCallback(
    (name, item) => {
      if (item?.length > 0) {
        const arrId = item.map((i: any) => i.id);
        dispatch({
          type: FilterActionEnum.UPDATE,
          payload: {
            constructionModuleId: new IdFilter({
              in: arrId,
            }),
            constructionModuleValue: item,
          },
        });
      } else {
        const modelFilterHere = cloneDeep(modelFilter);
        modelFilterHere.constructionModuleId = undefined;
        modelFilterHere.constructionModuleValue = undefined;
        dispatch({
          type: FilterActionEnum.UPDATE,
          payload: {
            ...modelFilterHere,
          },
        });
      }
    },
    [dispatch, modelFilter]
  );

  const columns: ColumnProps<LoggingApi>[] = useMemo(
    () => [
      {
        title: () => {
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.stt")}
              />
            </div>
          );
        },
        key: nameof(list[0].id),
        dataIndex: nameof(list[0].id),
        width: 50,
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={String(params[2] + 1)} />
            </LayoutCell>
          );
        },
        fixed: "left",
      },
      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "url"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.link")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].externalServiceApi.url),
        dataIndex: nameof(list[0].externalServiceApi.url),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].externalServiceApi.url)
        ),
        width: 200,
        fixed: "left",
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                link={
                  params[1]?.externalServiceApi?.externalService?.hostname +
                  params[1]?.externalServiceApi?.url
                }
                value={
                  params[1]?.externalServiceApi?.externalService?.hostname +
                  params[1]?.externalServiceApi?.url
                }
                countCharacters={30}
              />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "description"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title="Mô tả"
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        width: 200,
        key: nameof(list[0].externalServiceApi.description),
        dataIndex: nameof(list[0].externalServiceApi.description),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].externalServiceApi.description)
        ),
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                value={params[1]?.externalServiceApi.description}
                countCharacters={30}
              />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "httpRequestMethod"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("Phương thức")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        width: 80,
        key: nameof(list[0].externalServiceApi.httpRequestMethod),
        dataIndex: nameof(list[0].externalServiceApi.httpRequestMethod),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].externalServiceApi.httpRequestMethod)
        ),
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                value={params[1]?.externalServiceApi?.httpRequestMethod}
                countCharacters={30}
              />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "constructionModule"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("Phân hệ")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        width: 80,
        key: nameof(list[0].constructionModule),
        dataIndex: nameof(list[0].constructionModule),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].constructionModule)
        ),
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                value={params[1]?.constructionModule?.name}
                countCharacters={30}
              />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "requestBody"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.requestBody")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        width: 300,
        key: nameof(list[0].requestBody),
        dataIndex: nameof(list[0].requestBody),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].requestBody)
        ),
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <div className="d-flex w-100 justify-content-between">
                <OneLineText
                  value={params[1]?.requestBody}
                  countCharacters={100}
                />
                <Tooltip title={translate("loggingApi.copy")}>
                  <div className="hover-class">
                    <CopyToClipboard text={params[1]?.requestBody}>
                      <Copy16></Copy16>
                    </CopyToClipboard>
                  </div>
                </Tooltip>
              </div>
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "requestHeader"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.requestHeader")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        width: 120,
        key: nameof(list[0].requestHeader),
        dataIndex: nameof(list[0].requestHeader),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].requestHeader)
        ),
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            //fill the change the render field after generate code;
            //if status change OneLine = StatusLine
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                value={params[1]?.requestHeader}
                countCharacters={30}
              />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "responseStatus"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.responseStatus")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].responseStatus),
        dataIndex: nameof(list[0].responseStatus),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].responseStatus)
        ),
        width: 130,
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md" position="right">
              <OneLineText value={params[1].responseStatus} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "responseBody"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.responseBody")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].responseBody),
        dataIndex: nameof(list[0].responseBody),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].responseBody)
        ),
        width: 220,
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <div className="d-flex w-100 justify-content-between">
                <OneLineText
                  value={params[1].responseBody}
                  countCharacters={30}
                />
                <Tooltip title={translate("loggingApi.copy")}>
                  <div className="hover-class">
                    <CopyToClipboard text={params[1]?.responseBody}>
                      <Copy16></Copy16>
                    </CopyToClipboard>
                  </div>
                </Tooltip>
              </div>
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "retryCount"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.retryCount")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].retryCount),
        dataIndex: nameof(list[0].retryCount),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].retryCount)
        ),
        width: 120,
        ellipsis: true,
        render(...params: [number, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md" position="right">
              <OneLineText value={params[1].retryCount.toString()} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "createdAt"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.createdAt")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].createdAt),
        dataIndex: nameof(list[0].createdAt),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].createdAt)
        ),
        width: 200,
        ellipsis: true,
        render(...params: [Moment, LoggingApi, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={formatDateTime(params[0])} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "requestUuid"
          );
          return (
            <div>
              <LayoutHeader
                orderType="left"
                title={translate("loggingApi.requestUuid")}
                sortedColumn={sortedColumn}
                isSorter
              />
            </div>
          );
        },
        key: nameof(list[0].requestUuid),
        dataIndex: nameof(list[0].requestUuid),
        sorter: true,
        sortOrder: getAntOrderType<LoggingApi, LoggingApiFilter>(
          filter,
          nameof(list[0].requestUuid)
        ),
        width: 200,
        ellipsis: true,
        render(...params: [string, LoggingApi, number]) {
          return (
            //fill the change the render field after generate code;
            //if status change OneLine = StatusLine
            <LayoutCell orderType="left" tableSize="md">
              <div className="d-flex w-100 justify-content-between">
                <OneLineText
                  value={params[1].requestUuid}
                  countCharacters={30}
                />
                <Tooltip title={translate("loggingApi.copy")}>
                  <div className="hover-class">
                    <CopyToClipboard text={params[1]?.requestUuid}>
                      <Copy16></Copy16>
                    </CopyToClipboard>
                  </div>
                </Tooltip>
              </div>
            </LayoutCell>
          );
        },
      },

      {
        title: translate("general.actions.label"),
        key: "action",
        dataIndex: nameof(list[0].id),
        fixed: "right",
        width: 80,
        align: "center",
        render(id: number) {
          return (
            <div className="d-flex justify-content-center button-action-table">
              <div className="d-flex button-action-table missions-dxg">
                <div className="enable-dxg">
                  <Tooltip title={translate("loggingApi.reSend")}>
                    <WatsonHealthRotate36024
                      className="btn-missions-green"
                      onClick={() => {
                        handleSend(id);
                      }}
                    ></WatsonHealthRotate36024>
                  </Tooltip>
                </div>
              </div>
            </div>
          );
        },
      },
    ],
    [translate, list, filter, handleSend]
  );

  return (
    <>
      <Spin spinning={loading}>
        <div
          className="page-content page-content-dxg"
          id={"page-content-dxg-id"}
        >
          <div className="info-component  mb-3">
            <span>{translate("loggingApi.master.header")}</span>
            <span> &gt; </span>
            <span className="info-primary">
              {translate("loggingApi.master.subHeader")}
            </span>
          </div>
          <div className="page page-master m-t--lg  m-b--xxs">
            <div className="page-master__content">
              <div className="pt-3 pb-1 ml-3">
                <h5 className="font-bold page-title">
                  {translate("loggingApi.master.subHeader")}
                </h5>
              </div>
              <div className="page-master__tag-filter">
                <TagFilter
                  value={filter}
                  translate={translate}
                  keyTranslate={"loggingApi"}
                  handleChangeFilter={handleChangeAllFilter}
                  onClear={(value: any) => {
                    return 0;
                  }}
                />
              </div>

              <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between">
                <div className="page-master__filter d-flex align-items-center justify-content-start">
                  <div className="d-flex align-items-center">
                    <div className="mr-3">
                      <AdvanceIdFilterMaster
                        value={filter[nameof(list[0].responseStatus)]["equal"]}
                        classFilter={LoggingApiFilter}
                        searchProperty={"search"}
                        searchType={""}
                        onChange={handleChangeSelectFilterHere({
                          fieldName: nameof(list[0].responseStatus),
                          fieldType: "equal",
                          classFilter: IdFilter,
                        })}
                        getList={logginApiRepository.filterListHttpStatusCode}
                        label={translate("loggingApi.responseStatus")}
                        render={(responseStatus) => {
                          return `${responseStatus?.id} - ${responseStatus?.code}`;
                        }}
                      />
                    </div>
                    <div className="mr-3 select-log-api">
                      <Select
                        mode="multiple"
                        value={filter?.constructionModuleValue}
                        options={arrFilterConstructionModule}
                        onChange={(name, item) =>
                          handleChangeFilterConstructionModule(name, item)
                        }
                        filterOption={false}
                        className="w-100"
                        allowClear
                        maxTagCount={1}
                        placeholder="Phân hệ"
                        dropdownStyle={{ minWidth: "120px" }}
                        suffixIcon={<ArrowDown16 />}
                      ></Select>
                    </div>

                    <div style={{ minWidth: "270px" }} className="mr-3">
                      <AdvanceDateRangeFilter
                        onChange={handleChangeDateFilter({
                          fieldName: "createdAt",
                          fieldType: ["greaterEqual", "lessEqual"],
                        })}
                        value={[
                          modelFilter?.createdAt?.greaterEqual,
                          modelFilter?.createdAt?.lessEqual,
                        ]}
                        placeholder={[
                          translate("loggingApi.placeholder.atFrom"),
                          translate("loggingApi.placeholder.atTo"),
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className="page-master__filter-action-search d-flex align-items-center">
                  <InputSearch
                    value={filter?.search}
                    classFilter={LoggingApiFilter}
                    placeHolder={translate("general.placeholder.search")}
                    onChange={handleChangeInputSearch}
                  />
                </div>
                <div className="page-master__filter-action d-flex align-items-center">
                  <Tooltip title={translate("general.actions.export")}>
                    <div className={"mr-2"}>
                      <Button
                        type="icon-only-ghost"
                        icon={<Download16 />}
                        onClick={handleListExport(
                          filter,
                          logginApiRepository.export
                        )}
                        className="btn--xl btn-grey ml-3"
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="page-master__content-table">
              <ActionBarComponent
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                translateTitleCancelButton={translate("general.actions.close")}
              >
                <Button
                  icon={<TrashCan16 />}
                  type="ghost-primary"
                  className="btn--lg"
                  disabled={!canBulkAction}
                  onClick={() => handleBulkAction(selectedRowKeys)}
                >
                  {translate("general.actions.delete")}
                </Button>
              </ActionBarComponent>
              <StandardTable
                rowKey={nameof(list[0].id)}
                columns={columns}
                dataSource={list}
                isDragable={true}
                tableSize={"md"}
                onChange={handleTableChange}
                loading={loadingList}
                scroll={{ x: 2500 }}
                bordered
                className="mt-2"
                rowSelection={rowSelection}
              />
              <Pagination
                skip={filter?.skip}
                take={filter?.take}
                total={count}
                onChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
}

export default AppLoggingApiMaster;
